import {displayPaymentErrorMessage, type OrderService} from '../order';
import {type GatewayConfiguration} from '../../models/GatewayConfiguration';
import {Feature, stopModalLoading} from '../../reducers/environmentReducer';
import {getLocaleText} from '../../util/translation';
import {addButtonListener, defaultOrderFlow} from './peachpay';
import {FeatureFlag} from '../../../../@type/features';
import codImageURL from '../../../img/marks/cash.svg';
import {getErrorString} from '../../../../@shared/ts/error';
import {store} from '../../store';

export function initCODSupport(orderService: OrderService) {
	if (!Feature.enabled(FeatureFlag.WOOCOMMERCE_COD_GATEWAY)) {
		return;
	}

	addButtonListener(getCODMethodConfiguration().gatewayId, async () => {
		const {error: transactionError, result: transaction} = await orderService.startTransaction(getCODMethodConfiguration().gatewayId);
		if (transactionError || !transaction) {
			const errorMessage = transactionError ? getErrorString(transactionError) : getLocaleText('An unknown error occured while starting the transaction. Please refresh the page and try again.');
			displayPaymentErrorMessage(errorMessage);

			store.dispatch(stopModalLoading());
			return;
		}

		await defaultOrderFlow(orderService, transaction);
	});
}

export function getCODMethodConfiguration(): GatewayConfiguration {
	return {
		name: getTitle(),
		gatewayId: 'cod',
		description: getDescription(),
		assets: {
			title: {src: codImageURL},
			badge: {src: codImageURL},
		},
	};
}

function getTitle(): string {
	return Feature.metadata(FeatureFlag.WOOCOMMERCE_COD_GATEWAY, 'title') ?? getLocaleText('Cheque');
}

function getDescription(): string {
	const description = Feature.metadata<string>(FeatureFlag.WOOCOMMERCE_COD_GATEWAY, 'description') ?? getLocaleText('Pay with a cheque');
	const instructions = Feature.metadata<string>(FeatureFlag.WOOCOMMERCE_COD_GATEWAY, 'instructions') ?? '';
	if (instructions) {
		return /* html */ `
			<span>${description}</span>
			</br></br>
			<span>${instructions}</span>
		`;
	}

	return description;
}
